import { Stack } from "@mantine/core"
import { LabelWithTooltip, Select } from "@tfg/ui"

import { getNestedError } from "~/pages/Admin/components/Fields/utils"
import { FormFieldConfig } from "~/pages/Admin/components/form.types"

export const SelectField = (field: FormFieldConfig, form: any) => {
  const errors = getNestedError(form.errors, field.name)
  return (
    <Stack gap="var(--mantine-spacing-xxs)">
      {field.tooltip && (
        <LabelWithTooltip
          label={field.label}
          hoverHelperText={field.tooltip}
          justify="space-between"
          fw={600}
          withAsterisk={field.required ?? false}
        />
      )}
      <Select
        key={field.name}
        errorOnTouch={false}
        error={errors}
        label={!field.tooltip ? field.label : undefined}
        placeholder={field.placeholder}
        classNames={field.customClass}
        labelProps={{
          fz: "xs",
          fw: 600,
        }}
        clearable={field.clearable ?? true}
        searchable
        // this will show errors for user that touch the
        //  select field and dont input value if required
        onBlurCapture={() => {
          form.validateField(field.name)
        }}
        data={
          field.options?.map((data) => ({
            label: data.label,
            value: data.value,
          })) || []
        }
        {...form.getInputProps(field.name)}
        onChange={(value) => {
          form.setFieldValue(field.name, value)
          form.validateField(field.name)
        }}
        disabled={field.disabled}
      />
    </Stack>
  )
}
